export * from './university.service';
